import { Icon } from 'ant-design-vue'
export default Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2733983_xpe6ry6wl3.js'
})
